import { cn } from "@do/ui/lib/utils";

type MessageSeparatorProps = {
  text: string;
  id: string;
};

export const MessageSeparator = ({ text, id }: MessageSeparatorProps) => {
  return (
    <div
      id={id}
      className={cn(
        "flex items-center",
        "my-(--message-separator-margin-y)",
        "gap-(--message-separator-gap)",
        "text-(length:--message-separator-font-size)",
        "text-(--message-separator-color)/(--message-separator-color-opacity)",
        "font-(--message-separator-font-weight)!",
        "font-(family-name:--message-separator-font-family)",
        "before:flex-1 before:border-t-(length:--message-separator-border-width) before:border-t-(--message-separator-border-color)/(--message-separator-border-opacity)",
        "after:flex-1 after:border-t-(length:--message-separator-border-width) after:border-t-(--message-separator-border-color)/(--message-separator-border-opacity)"
      )}
      aria-label={text}
      role="separator"
    >
      <span className="text-center whitespace-normal break-words">{text}</span>
    </div>
  );
};
